import { Injectable } from '@angular/core';
import swal from "sweetalert2";

@Injectable({
  providedIn: 'root'
})
export class InformedAlertService {

  showSuccessAlert(message: any) {
    return swal
      .fire({
        icon: "success",
        text: message,
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonColor: "#5A50CC",
        cancelButtonColor: "#ffffff",
        confirmButtonText: "Ok",
        cancelButtonText: "No",
        reverseButtons: true,
        customClass: "swal-Finndit",
        width: 500,
      });
  }
}
